import { InjectionToken } from '@angular/core'

export interface Environment {
  production: boolean

  apiUrl: string
  socketUrl: string

  posthog: {
    apiKey: string
    apiHost: string
  }
}

export const ENVIRONMENT = new InjectionToken<Environment>('Environment token')
